<template>
  <task-list :filter-status="filter.backlog" :values-blocks="['planning']"></task-list>
</template>

<script>
import taskList from '@/components/TaskList'
import { mapState } from 'pinia/dist/pinia'
import { useTasksStore } from '@/stores/tasks'

export default {
  name: 'PageBacklog',
  components: {
    taskList,
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapState(useTasksStore, ['filter']),
  },
  methods: {

  },
  mounted () {

  },
}
</script>
